module.exports = __webpack_public_path__ + "static/img/门诊缴费@3x.03ff3bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/butler/门诊缴费@3x.png
// module id = 785
// module chunks = 358